const config = typeof window !== 'undefined' ? window.spectroCoinFeConfig : {};

interface SpectroCoinFeConfig {
	FACEBOOK_PIXEL_ID?: string;
	GTM_ID?: string;
	HOTJAR_ID?: string;
	INCLUDE_FB_PIXEL?: boolean;
	IS_HOTJAR_TRACKING_ENABLED?: boolean;
	TWITTER_PIXEL_ID?: string;
	AUTH_DOMAIN?: string;
}

declare global {
	interface Window {
		spectroCoinFeConfig: SpectroCoinFeConfig;
		debugMode: boolean;
		gtag: (...x: any) => void;
		fbq: any;
	}
}

export default {
	FACEBOOK_PIXEL_ID: '814978501880345',
	HOTJAR_ID: '868148',
	INCLUDE_FB_PIXEL: true,
	IS_HOTJAR_TRACKING_ENABLED: false,
	TWITTER_PIXEL_ID: '814978501880345',
	AUTH_DOMAIN: '',
	...config,
};
